import { folderRiskStatusFrag } from '../../../../../../services/types/folder.types';
import { personAddressFrag } from '../../../../service/types/person.types';

export const riskyClientFrag = `
            ${folderRiskStatusFrag}
            folder {
                serviceId
                person {
                    name
                    surname
                    birthdate
                    addresses {
                        ${personAddressFrag}
                    }
                }
            }
        `;
